export default __webpack_public_path__ + "static/wall_street-1827cce6500b29d1d1697dac90d842aa.svg";